import { Steps } from "antd";
import React, { useEffect, useState } from "react";
const { Step } = Steps;
import succeed from '../../assets/submit-img.png';
import '../../styles/LastTab.scss';

import { SubmitStatus as ST } from '../../utils/BaseVar';
import { CSSTransition } from 'react-transition-group';
import StepsIcon from '../../components/StepsIcon';
const SubmitResult = (props) => {
  const { title, sendStatus, submitTime, setFirst } = props;
  const [showSubmit, setShowSubmit] = useState(true);
  const [countTime, setCountTime] = useState(0);
  const [curStatusStep, setCurStatusStep] = useState(0);
  const [showSteps, setShowSteps] = useState(false);

  const showTryAgain = (sendStatus === ST.CREATE_FAILED) || (sendStatus === ST.RUN_FAILED);
  const showList = sendStatus === ST.RUN_SUCCEEDED;

  let submitIcon = <StepsIcon type='checked' showLarge={sendStatus === ST.SUBMIT_SUCCEEDED || sendStatus === ST.CREATE_PROCESSING || sendStatus === ST.CREATE_WAITING} />;

  // submit
  const submitText = (() => {
    return "Job configure has been completed!";
  })();

  // create
  const createText = (() => {
    if (sendStatus === ST.CREATE_FAILED) {
      return "Failed to create!";
    }
    if (sendStatus === ST.CREATE_PROCESSING) {
      return "Job is creating!";
    }
    if (curStatusStep > ST.SEND_STEP_CREATE) {
      return "Job is created successfully!";
    }
    return "Job is waiting to create";
  })();

  const createIcon = (() => {
    if (sendStatus === ST.CREATE_FAILED) {
      return (<StepsIcon type='fail' showLarge={true} />);
    }
    if (sendStatus === ST.CREATE_PROCESSING) {
      return (<StepsIcon type='wait' showLarge={false} />);
    }
    return (<StepsIcon type='checked' showLarge={sendStatus === ST.CREATE_SUCCEEDED || sendStatus === ST.RUN_PROCESSING} />);

  })();

  const runText = (() => {
    if (sendStatus === ST.CREATE_FAILED) {
      return "Failed to create!";
    }
    if (sendStatus === ST.RUN_FAILED) {
      return "Created successfully, but failed to run!";
    }
    if (sendStatus === ST.RUN_SUCCEEDED) {
      return "Job is submitted successfully!";
    }
    if (curStatusStep < ST.SEND_STEP_RUN || sendStatus === ST.RUN_PROCESSING) {
      return "Job is waiting!";
    }
    return "Job is waiting!";
  })();

  const runIcon = (() => {
    if (sendStatus === ST.CREATE_FAILED) {
      return (<StepsIcon type='fail' showLarge={true} />);
    }
    if (sendStatus === ST.RUN_FAILED) {
      return (<StepsIcon type='fail' showLarge={true} />);
    }
    if (sendStatus === ST.RUN_SUCCEEDED) {
      return (<StepsIcon type='checked' showLarge={true} />);
    }
    if (curStatusStep < ST.SEND_STEP_RUN || sendStatus === ST.RUN_PROCESSING) {
      return (<StepsIcon type='wait' />);
    }
    return (<StepsIcon type='wait' />);
  })();

  useEffect(() => {
    setTimeout(
      () => {
        setShowSubmit(false);
      },
      1000);
    setTimeout(() => {
      setShowSteps(true);
    }, 1500);
  }, []);

  useEffect(() => {
    if (sendStatus === ST.RUN_SUCCEEDED || sendStatus === ST.RUN_FAILED || sendStatus === ST.CREATE_FAILED) {
      return;
    }
    const timerId = setInterval(() => {
      setCountTime(Math.round((Date.now() - submitTime) / 1000));
    }, 1000);
    return () => clearInterval(timerId);
  }, [countTime]);

  useEffect(() => {
    if (sendStatus < ST.CREATE_SUCCEEDED) {
      setCurStatusStep(ST.SEND_STEP_SUBMIT);
    }
    else if (sendStatus < ST.RUN_SUCCEEDED) {
      setCurStatusStep(ST.SEND_STEP_CREATE);
    }
    else {
      setCurStatusStep(ST.SEND_STEP_RUN);
    }
  }, [sendStatus]);

  return (
    <div className="last-tab-container">
      <div className="task-name-container">
        <p className="task-name">{title}</p>
      </div>
      <div className="content-wrapper">
        {/* <CSSTransition
          in={showSubmit}
          timeout ={1000}
          classNames = 'move'
          unmountOnExit
          apper={true}
        >
          <div className="submit-wrapper">
            <div className="img-container">
              <img width="140" height="140" src={succeed}/>
            </div>
            <div className="submit-text-wrapper">
              <div className="first-title-container">
                <p>Submitted</p>
              </div>
              <div className="second-title-container">
                <p>Job configure has been submitted</p>
              </div>
            </div>
          </div>
        </CSSTransition> */}
        <CSSTransition
          in={showSteps}
          timeout={1000}
          classNames='steps'
          unmountOnExit
          appear={true}
        >
          <div className="steps-container">
            <Steps direction="vertical" current={curStatusStep}>
              {/* <Step title="Submitted" description={submitText} icon={submitIcon}/>
              <Step title="Created" description={createText} icon={createIcon}/> */}
              <Step title="Job Status" description={runText} icon={runIcon} />
            </Steps>
          </div>
        </CSSTransition>
      </div>
      <div className="footer">
        {showTryAgain ? (<div>Please <span className="link-text" onClick={setFirst}><b>Create</b></span> again later.</div>) : null}
        {showList ? (<div>Please check the <a href="/challenge"><b>job list</b></a> for AlphaRTC logs.</div>) : null}
      </div>
    </div>
  );
};

export default SubmitResult;